import * as React from 'react';
const SvgWarning = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 8.003a8 8 0 1016 0 8 8 0 00-16 0zm14 0a6 6 0 11-12 0 6 6 0 0112 0zM6.86 11.03c0-.672.492-1.14 1.14-1.14.648 0 1.14.468 1.14 1.14 0 .672-.492 1.14-1.14 1.14-.648 0-1.14-.468-1.14-1.14zM7.58 4h.842a.75.75 0 01.747.825l-.373 3.724a.5.5 0 01-.497.45h-.596a.5.5 0 01-.497-.45l-.373-3.724A.75.75 0 017.58 4z"
            fill="currentColor"
        />
    </svg>
);
export default SvgWarning;
